import { render, staticRenderFns } from "./ScormPreview.vue?vue&type=template&id=54b709a9&"
import script from "./ScormPreview.vue?vue&type=script&lang=js&"
export * from "./ScormPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports